var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.9585C10.3452 8.9585 10.625 9.23832 10.625 9.5835V13.7502C10.625 14.0953 10.3452 14.3752 10 14.3752C9.65482 14.3752 9.375 14.0953 9.375 13.7502V9.5835C9.375 9.23832 9.65482 8.9585 10 8.9585Z",
    fill: "#727272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.50016C10.4602 7.50016 10.8333 7.12707 10.8333 6.66683C10.8333 6.20659 10.4602 5.8335 10 5.8335C9.53977 5.8335 9.16667 6.20659 9.16667 6.66683C9.16667 7.12707 9.53977 7.50016 10 7.50016Z",
    fill: "#727272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70834 10.0002C2.70834 5.97309 5.97293 2.7085 10 2.7085C14.0271 2.7085 17.2917 5.97309 17.2917 10.0002C17.2917 14.0272 14.0271 17.2918 10 17.2918C5.97293 17.2918 2.70834 14.0272 2.70834 10.0002ZM10 3.9585C6.66328 3.9585 3.95834 6.66344 3.95834 10.0002C3.95834 13.3369 6.66328 16.0418 10 16.0418C13.3367 16.0418 16.0417 13.3369 16.0417 10.0002C16.0417 6.66344 13.3367 3.9585 10 3.9585Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/Info_circle.0e0a89f918f69e41bdfc99c23100f8d5.svg";
export { ForwardRef as ReactComponent };